export enum PLAY {
    /**
     * @value Add to gallery
     * @description Title of the notification dialog displayed when a new playlist is saved
     */
    ADD_TO_GALLERY = 'PLAY.ADD_TO_GALLERY',
    /**
     * @value Allow users to download the video from the video page
     * @description Description of a switch to allow users to download video
     */
    ALLOW_TO_DOWNLOAD_VIDEO = 'PLAY.ALLOW_TO_DOWNLOAD_VIDEO',
    /**
     * @value Archive
     */
    ARCHIVE = 'ADMIN_CONTENT_STATUS_PAGE_ARCHIVE',
    /**
     * @value Ask video
     * @description New button ask video in video and playlist landing page
     */
    ASK_VIDEO = 'PLAY.ASK_VIDEO',
    /**
     * @value Display in search results
     * @description Text used as a label of a switch toggle form field where user can choose if a video is visible in search results
     */
    AVAILABILITY_SEARCH_TITLE = 'PLAY.AVAILABILITY_SEARCH_TITLE',
    /**
     * @value Back to Home
     * @description Label of the button that lets the user go back to the home page from a different page.
     */
    BACK_TO_HOME = 'GLOBAL.BACK_TO_HOME',
    /**
     * @value {"one":"Change author","other":"Change authors"}
     * @description Text used on a button inviting our users to change video authors
     */
    CHANGE_AUTHORS = 'PLAY.CHANGE_AUTHORS',
    /**
     * @value Download video
     * @description Text used as a label on a button allowing the user to download the video source.
     */
    DOWNLOAD_VIDEO = 'PLAY.DOWNLOAD_VIDEO',
    /**
     * @value Edit video author
     */
    EDIT_VIDEO_AUTHOR = 'PLAY.EDIT_VIDEO_AUTHOR',
    /**
     * @value Encoding error
     * @description This error can appear when the processing of the video fail after the upload
     */
    ENCODING_ERROR = 'PLAY.ENCODING_ERROR',
    /**
     * @value Content, posts, comments…
     * @description Text used as a label description of a switch toggle form field where user can choose if a video can be embedded in the current site
     */
    INTEGRATION_IN_SITE_DESCRIPTION = 'PLAY.INTEGRATION_IN_SITE_DESCRIPTION',
    /**
     * @value Allow publication of this video on this site
     * @description Text used as a label of a switch toggle form field where user can choose if a video can be embedded in the current site
     */
    INTEGRATION_IN_SITE_TITLE = 'PLAY.INTEGRATION_IN_SITE_TITLE',
    /**
     * @value Users with visibility rights can select this playlist from the Play picker for a piece of content, community post, or comment.
     * @description If you enable this option, the video is listed in the Play picker for users with visibility rights. If you disable this option, the video does not appear in the picker for any user, which makes adding the video to a piece of content, community post, or comment impossible.
     *
     * "Playlist" should not be translated.
     */
    INTEGRATION_PLAYLIST_IN_SITE_DESCRIPTION = 'PLAY.INTEGRATION_PLAYLIST_IN_SITE_DESCRIPTION',
    /**
     * @value Users with visibility rights can select this video from the Play picker for a piece of content, community post, or comment.
     * @description Enable this option, the video is listed in the Play picker for users with visibility rights. If you disable this option, the video does not appear in the picker for any user, which makes adding the video to a piece of content, community post, or comment impossible.
     */
    INTEGRATION_VIDEO_IN_SITE_DESCRIPTION = 'PLAY.INTEGRATION_VIDEO_IN_SITE_DESCRIPTION',
    /**
     * @value Maximum file size: %SIZE%
     * @description Maximum file size to import a video
     */
    MAX_FILE_SIZE = 'PLAY.MAX_FILE_SIZE',
    /**
     * @value Most viewed
     * @description Used, for example, in a dropdown to sort videos by their number of views
     */
    MOST_VIEWED = 'PLAY.MOST_VIEWED',
    /**
     * @value You don‘t have any videos
     * @description The library has no video to display
     */
    NO_AVAILABLE_VIDEOS = 'PLAY.NO_AVAILABLE_VIDEOS',
    /**
     * @value There is no video
     * @description Text used to warn the user that there is no video (in the library, the gallery, the playlist etc...)
     */
    NO_VIDEO = 'PLAY.NO_VIDEO',
    /**
     * @value Play all
     * @description Text is used to invite the user to play all videos
     */
    PLAY_ALL = 'PLAY.PLAY_ALL',
    /**
     * @value Play video
     * @description Play video
     */
    PLAY_VIDEO = 'PLAY.PLAY_VIDEO',
    /**
     * @value Publication
     * @description Title of the Scheduled section in the edit dialog
     * Defines a video publication
     */
    PUBLICATION = 'PLAY.PUBLICATION',
    /**
     * @value Restricted video
     * @description Test used when a video from a playlist is not available for the user
     */
    RESTRICTED_VIDEO = 'PLAY.RESTRICTED_VIDEO',
    /**
     * @value Search videos
     * @description Generic search videos label (used in text field as placeholder, could be use as a button label etc…)
     */
    SEARCH_VIDEOS = 'PLAY.SEARCH_VIDEOS',
    /**
     * @value {"one":"You selected %NB_VIDEO% videos from 1 author.","other":"You selected %NB_VIDEO% videos from %NB_AUTHOR% authors."}
     * @description Shows the user the number of videos selected and the number of video authors.
     */
    SELECTED_NB_VIDEO_FROM_NB_AUTHOR = 'PLAY.SELECTED_NB_VIDEO_FROM_NB_AUTHOR',
    /**
     * @value You selected 1 video from 1 author.
     * @description Tells the user he selected one video from one author.
     */
    SELECTED_VIDEO_FROM_AUTHOR = 'PLAY.SELECTED_VIDEO_FROM_AUTHOR',
    /**
     * @value Supported format: %FORMATS%
     * @description List of supported format for videos (.mp4, .avi...)
     */
    SUPPORTED_VIDEO_FORMATS = 'PLAY.SUPPORTED_VIDEO_FORMATS',
    /**
     * @value Unpublish
     */
    UNPUBLISH = 'CONTENT_SET_TO_DRAFT',
    /**
     * @value You have reached your maximum LumApps Play consumption, please contact your administrator for more information.
     */
    UPLOAD_DIALOG_CONSUMPTION_WARNING = 'PLAY.UPLOAD_DIALOG_CONSUMPTION_WARNING',
    /**
     * @value Upload to your library
     * @description Text that appears when the user drags and drops a file into the subtitle uploader
     */
    UPLOAD_TO_LIBRARY = 'PLAY.UPLOAD_TO_LIBRARY',
    /**
     * @value Videos cannot be uploaded or replaced. Contact your platform administrator to activate this Play feature again.
     * @description Message showing in the widget play and widget playlist if play is disabled on the platform
     */
    UPLOAD_VIDEO_DISABLED = 'PLAY.UPLOAD_VIDEO_DISABLED',
    /**
     * @value Video authors changed
     * @description Text used to notify the user that he successfully changed video authors
     */
    VIDEO_AUTHORS_CHANGED = 'PLAY.VIDEO_AUTHORS_CHANGED',
    /**
     * @value The video author has edition rights on the video. Their name will be displayed on the video details.
     * @description Help text explaining to the user what a video author can do.
     */
    VIDEO_AUTHOR_HELPER = 'PLAY.VIDEO_AUTHOR_HELPER',
    /**
     * @value Video encoding
     * @description Text indicating to our users that a video is being encoded.
     */
    VIDEO_BEING_ENCODED = 'PLAY.VIDEO_BEING_ENCODED',
    /**
     * @value Uploaded
     * @description Uploaded label
     */
    VIDEO_DATE_PUBLISHED = 'PLAY.VIDEO_DATE_PUBLISHED',
    /**
     * @value Video deleted
     * @description Text indicating to our users that a video is deleted
     */
    VIDEO_DELETED = 'PLAY.VIDEO_DELETED',
    /**
     * @value %NB% videos deleted
     * @description Text indicating to our users how many videos are deleted
     */
    VIDEO_DELETED_COUNT = 'PLAY.VIDEO_DELETED_COUNT',
    /**
     * @value Video gallery
     * @description Title of the video gallery
     */
    VIDEO_GALLERY_TITLE = 'PLAY.VIDEO_GALLERY_TITLE',
    /**
     * @value This video has restricted access.
     * @description Text indicating to our users that a video has restricted access.
     */
    VIDEO_HAS_RESTRICTED_ACCESS = 'PLAY.VIDEO_HAS_RESTRICTED_ACCESS',
    /**
     * @value Video information
     * @description Informations about the video
     */
    VIDEO_INFORMATION = 'PLAY.VIDEO_INFORMATION',
    /**
     * @value Manage roles
     * @description Label of the button allowing authorized users to manage user roles in the Play library
     */
    VIDEO_LIBRARY_EDIT_ROLES_CTA = 'PLAY.VIDEO_LIBRARY_EDIT_ROLES_CTA',
    /**
     * @value Filter by title or description
     * @description Placeholder for video search
     */
    VIDEO_LIBRARY_SEARCH_PLACEHOLDER = 'PLAY.VIDEO_LIBRARY_SEARCH_PLACEHOLDER',
    /**
     * @value Video manager
     * @description Title of the management page of the videos
     */
    VIDEO_LIBRARY_TITLE = 'PLAY.VIDEO_LIBRARY_TITLE',
    /**
     * @value This video no longer exists.
     * @description Text indicating to our users that a video does not longer exists.
     */
    VIDEO_NO_LONGER_EXISTS = 'PLAY.VIDEO_NO_LONGER_EXISTS',
    /**
     * @value LumApps Play video player
     * @description Title of the video iframe
     */
    VIDEO_PLAYER_TITLE = 'PLAY.VIDEO_PLAYER_TITLE',
    /**
     * @value Archived
     * @description Status of the video
     */
    VIDEO_STATUS_ARCHIVED = 'PLAY.VIDEO_STATUS_ARCHIVED',
    /**
     * @value Archived on
     * @description This translation is followed by the date the video was archived on
     */
    VIDEO_STATUS_ARCHIVED_ON = 'PLAY.VIDEO_STATUS_ARCHIVED_ON',
    /**
     * @value Deleted
     * @description Status of the video
     */
    VIDEO_STATUS_DELETED = 'PLAY.VIDEO_STATUS_DELETED',
    /**
     * @value Draft
     * @description Status of the video
     */
    VIDEO_STATUS_DRAFT = 'PLAY.VIDEO_STATUS_DRAFT',
    /**
     * @value Encoding
     * @description Video encoding status
     */
    VIDEO_STATUS_ENCODING = 'PLAY.VIDEO_STATUS_ENCODING',
    /**
     * @value Error
     * @description Error video status
     */
    VIDEO_STATUS_ERROR = 'PLAY.VIDEO_STATUS_ERROR',
    /**
     * @value Expired
     * @description Status of a video when expired
     */
    VIDEO_STATUS_EXPIRED = 'PLAY.VIDEO_STATUS_EXPIRED',
    /**
     * @value Expired on
     * @description This translation is followed by the date the video expired
     */
    VIDEO_STATUS_EXPIRED_ON = 'PLAY.VIDEO_STATUS_EXPIRED_ON',
    /**
     * @value Published
     * @description Status of the video
     */
    VIDEO_STATUS_PUBLISHED = 'PLAY.VIDEO_STATUS_PUBLISHED',
    /**
     * @value Unpublished
     * @description Status of the video
     */
    VIDEO_STATUS_UNPUBLISHED = 'PLAY.VIDEO_STATUS_UNPUBLISHED',
    /**
     * @value Unschedule
     * @description Action to unschedule a video visible by the user when the status of the video is "scheduled"
     */
    VIDEO_STATUS_UNSCHEDULE = 'PLAY.VIDEO_STATUS_UNSCHEDULE',
    /**
     * @value Status updated
     * @description Toaster telling the user the status of his video have been updated
     */
    VIDEO_STATUS_UPDATED = 'PLAY.STATUS_UPDATED',
    /**
     * @value Video thumbnail
     * @description ALT for the video thumbnail
     */
    VIDEO_THUMBNAIL = 'PLAY.VIDEO_THUMBNAIL',
    /**
     * @value Video not available
     * @description Text indicating to our users that a video is not available
     */
    VIDEO_UNAVAILABLE = 'PLAY.VIDEO_UNAVAILABLE',
    /**
     * @value This video is not available or might have been unpublished.
     * @description Text giving a little more detail to our users on why a video is not available
     */
    VIDEO_UNAVAILABLE_DESCRIPTION = 'PLAY.VIDEO_UNAVAILABLE_DESCRIPTION',
    /**
     * @value Video usage
     * @description Name of the tab opening the Video Usage panel
     */
    VIDEO_USAGE = 'PLAY.VIDEO_USAGE',
    /**
     * @value {"one":"%VIEWS% view","other":"%VIEWS% views"}
     * @description Number of views on the video
     */
    VIDEO_VIEWS = 'PLAY.VIDEO_LIST_ITEM_VIEWS',
    /**
     * @value Visit video page
     * @description Used, for example, in tooltips inviting the user to go to a video page.
     */
    VISIT_VIDEO_PAGE = 'PLAY.VISIT_VIDEO_PAGE',
    /**
     * @value Only Play contributors and administrators can be video authors.
     * @description Helper text telling the user what types of users can author videos
     */
    WHO_CAN_BE_VIDEO_AUTHOR = 'PLAY.WHO_CAN_BE_VIDEO_AUTHOR',
    /**
     * @value Wrong format file
     * @description Error message when upload wrong format file
     */
    WRONG_FORMAT_FILE = 'GLOBAL.WRONG_FORMAT_FILE',
}
